const EVENT_TYPE_ORDER = [
  'aufgabe',
  'termin',
  'entscheidung',
  'anforderung',
  'frage',
  'risiko',
  'annahme',
  'deferred',
  'sonstiges',
];

const LEGACY_TYPE_MAP = {
  functional: 'anforderung',
  nonfunctional: 'anforderung',
  constraint: 'anforderung',
  risk: 'risiko',
  assumption: 'annahme',
  open_question: 'frage',
  openquestion: 'frage',
};

const DEFAULT_LABELS = {
  aufgabe: 'Aufgabe',
  termin: 'Termin',
  entscheidung: 'Entscheidung',
  anforderung: 'Anforderung',
  frage: 'Frage',
  risiko: 'Risiko',
  annahme: 'Annahme',
  deferred: 'Vertagung',
  sonstiges: 'Sonstiges',
};

const DEFAULT_SUBTYPE_LABELS = {
  blocker: 'Blocker',
  dependency: 'Abhängigkeit',
};

export const isEventsV2Enabled = (config = window.__ANFORDERUNGSAI_CONFIG__ ?? {}) => {
  const value = config?.eventsV2Enabled;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'false' || normalized === '0' || normalized === 'off') return false;
  }
  return true;
};

export const normalizeEventType = (value, fallback = 'sonstiges') => {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (!normalized) return fallback;
  if (EVENT_TYPE_ORDER.includes(normalized)) return normalized;
  if (LEGACY_TYPE_MAP[normalized]) return LEGACY_TYPE_MAP[normalized];
  if (normalized.includes('anforder') || normalized.includes('requirement')) return 'anforderung';
  if (normalized.includes('frage') || normalized.includes('question')) return 'frage';
  if (normalized.includes('risiko') || normalized.includes('risk') || normalized.includes('blocker')) return 'risiko';
  if (normalized.includes('annahme') || normalized.includes('assumption')) return 'annahme';
  if (normalized.includes('defer') || normalized.includes('vertag') || normalized.includes('offen')) return 'deferred';
  if (normalized.includes('entschei') || normalized.includes('beschluss') || normalized.includes('decision')) return 'entscheidung';
  if (normalized.includes('termin') || normalized.includes('datum') || normalized.includes('deadline') || normalized.includes('zeit')) return 'termin';
  if (normalized.includes('aufgabe') || normalized.includes('task') || normalized.includes('todo') || normalized.includes('owner')) return 'aufgabe';
  return fallback;
};

export const normalizeEventSubtype = (value, fallback = '') => {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (!normalized) return fallback;
  if (normalized === 'blocker' || normalized.includes('block')) return 'blocker';
  if (normalized === 'dependency' || normalized.includes('depend') || normalized.includes('abhaeng') || normalized.includes('abhäng')) return 'dependency';
  return fallback;
};

export const labelForEventType = (value, labels = {}) => {
  const eventType = normalizeEventType(value);
  return labels[eventType] ?? DEFAULT_LABELS[eventType] ?? eventType;
};

export const labelForEventSubtype = (value, labels = {}) => {
  const eventSubtype = normalizeEventSubtype(value, '');
  if (!eventSubtype) return '';
  return labels[eventSubtype] ?? DEFAULT_SUBTYPE_LABELS[eventSubtype] ?? eventSubtype;
};

export const eventTypeOrder = EVENT_TYPE_ORDER;
